import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { Voucher } from '../../models/voucher';
import { RestProvider } from '../../providers/rest/rest';
import { ExpenseType, expense } from '../../models/expesetye';

/**
 * Generated class for the PagesExpenditurePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-pages-expenditure',
  templateUrl: 'pages-expenditure.html',
})
export class PagesExpenditurePage {
  expensetype: string;
  amount: any;
  paid_to: any;
  payment_for:any;
  date: any;

  voucherObj = new Voucher();
  expense_type_array: expense[] = [];
  showexpenses:boolean = false;
  petty_cash_balance:number;
  constructor(public restProvider: RestProvider,public navCtrl: NavController, public navParams: NavParams,private alertController:AlertController) {
  }

  ngOnInit()
  {
    this.date = new Date().toISOString().substring(0,10);
    console.log("current date: ",this.date);
    this.getexpenseType();
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad PagesExpenditurePage');
  }

  generateVoucher(){
    console.log("selected expense type:",this.expensetype);
    if(this.amount <= 0){
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Invalid Amount',
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return
    }
    if(this.paid_to == null || this.payment_for == null || this.amount == null){
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'All the fields are mandatory',
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return
    }
    this.voucherObj.amount = this.amount;
    var expensearray = this.expense_type_array.find((item) => item.name == this.expensetype);
    console.log("expensearray: ", expensearray);
    this.voucherObj.debit_account = expensearray.id;
    this.voucherObj.voucher_date = this.date;
    this.voucherObj.voucher_payee = this.paid_to;
    this.voucherObj.voucher_towards = this.payment_for;
    this.voucherObj.voucher_reference = null;
    console.log("voucher object:", this.voucherObj);
    this.restProvider.postVoucher(this.voucherObj)
    .subscribe(
      (result) => {
        console.log("pdf result: ",result);
        var fileURL = URL.createObjectURL(result);
                      console.log(fileURL)
                      window.open(fileURL);
          this.date = new Date().toISOString().substring(0,10);
          this.paid_to = null;
          this.payment_for = null;
          this.amount = null;
          this.expensetype = null;
      },
      error =>
      {
         console.log(error);

         let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Voucher Not Created',
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });
  
        alert.present();
  
        return
         //Put this statement just to continue while testing
        // this.navCtrl.push(TabsPage);

      }
    )
  }

  cancelVoucher(){
    // this.date = new Date().toISOString().substring(0,10);
    this.paid_to = null;
    this.payment_for = null;
    this.amount = null;
    this.expensetype = null;
    this.showexpenses = false;
  }

  getexpenseType(){
    this.restProvider.getExpenditureType().subscribe(
      (result: any) => 
      {
        console.log(result)
        this.expense_type_array = result.expense;
        this.petty_cash_balance = result.petty_cash_balance;
          console.log("expense type:",this.expense_type_array);
          if(this.expense_type_array.length > 0){
            this.expensetype = this.expense_type_array[0].name;
          }
      },
      error => {
        console.log(error);
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Expenditure types not found',
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });
  
        alert.present();
  
        return
   
      }
     )
  }

  showExpenseTypes(){
    this.showexpenses = !this.showexpenses;
  }
  setExpense(exp:ExpenseType){
    if(exp)
    {
     // this.expensetype = exp.name;
    }
    this.showexpenses = false;
  }
  closelist(){
    console.log("inside focusout")
    this.showexpenses = false;
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/pages-expenditure/pages-expenditure.ts